import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50b3f0db&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=50b3f0db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b3f0db",
  null
  
)

export default component.exports